import React, {useEffect, useState} from 'react';
import styles from "./warningTickers.module.scss";
import {v4 as uuidv4} from "uuid";
import {useAdvisors} from "../../../hooks/advisor.hook";
import {message as messageAnt} from "antd";

interface IProps {
  varForUpdate: string
}

//Тикеры уже не входящие в индекс s&p500, но по которым уже есть открытые позиции
const WarningTickers = ({varForUpdate}: IProps) => {

  const {loading, getTickersWithPositionsNotInSAndP, error, clearError} = useAdvisors()

  const [tickers, setTickers] = useState<string[]>([])

  //функция получение тикеров уже не входящих в индекс s&p500, но по которым уже есть открытые позиции
  const getTickers = async () => {
    try {
      const data = await getTickersWithPositionsNotInSAndP()
      messageAnt.info(data.message)
      return data.info
    } catch (e) {
      messageAnt.info(error);
      clearError()
      return []
    }
  }

  //изначальное получение тикеров уже не входящих в индекс s&p500, но по которым уже есть открытые позиции
  useEffect(() => {
    if (varForUpdate !== '') {
      const get = async () => {
        const tickers = await getTickers()
        if (tickers !== null) {
          setTickers(tickers)
        }
      }
      get()
    }
  }, [varForUpdate])

  if (tickers.length === 0) {
    return null
  }

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.wrap}>
          <p className={styles.title}
             title={'Тикеры уже не входящие в индекс s&p500, но по которым уже есть открытые позиции.'}>
            Список тикеров с открытыми позициями для самостоятельной проработки
          </p>
          <div>
            <p className={styles.line}>
              {
                tickers.map(ticker => (
                  <span key={uuidv4()}>{ticker} </span>
                ))
              }
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WarningTickers;